import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { PersonalDetailsTab } from 'src/components/CustomersBar/CustomerTab/PersonalDetailsTab/PersonalDetailsTab';
import MarketingTab from 'src/components/CustomersBar/CustomerTab/MarketingTab';
import { TransactionHistoryTab } from 'src/components/CustomersBar/CustomerTab/TransactionHistoryTab/TransactionHistoryTab';
import CustomerSettingsTab from 'src/components/CustomersBar/CustomerTab/CustomerSettingsTab';

import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';
import { List } from 'immutable';
import { CustomerSummaryTab } from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CustomerSummaryTab';
import { ResponsibleGamblingTab } from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ResponsibleGamblingTab';
import { CustomerSettingsTabNew } from 'src/components/CustomersBar/CustomerTab/CustomerSettingsTabNew/CustomerSettingsTab';
import { PromotionHistory } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/PromotionHistory';
import { BankingTab } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTab';
interface CustomerContentType {
    id: number;
    onQueryAudits: (
        id: string,
        topic: string,
        tag: string | Array<string>,
        filterName: string | null
    ) => (e: React.MouseEvent) => void;
    onShowAll: (id: string, topic: string, tag: Array<string>) => (e: React.MouseEvent) => void;
    customerData: StaffAccountBasicDataType;
    permissionGrants: List<unknown>;
}

export const CustomerContent = observer((props: CustomerContentType): JSX.Element | null => {
    const {
        routerBackoffice,
        configState: {
            config: { closureCodes, promotionHistoryEnabled },
        },
    } = useAppStateContext();
    const { id, onShowAll, onQueryAudits, permissionGrants } = props;
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab') ?? 'customer-summary';

    if (customerParams === 'banking') {
        return (
            <BankingTab
                id={id}
                onQueryAudits={onQueryAudits}
                showAllAudits={onShowAll}
                permissionGrants={permissionGrants}
            />
        );
    }

    if (customerParams === 'customer-settings') {
        return (
            <CustomerSettingsTab
                id={id}
                closureCodes={closureCodes}
            />
        );
    }

    if (customerParams === 'customer-settings-new') {
        return <CustomerSettingsTabNew id={id} />;
    }

    if (customerParams === 'customer-promotion-history' && promotionHistoryEnabled) {
        return <PromotionHistory userId={id} />;
    }

    if (customerParams === 'marketing') {
        return <MarketingTab id={id} />;
    }

    if (customerParams === 'personal-details') {
        return <PersonalDetailsTab customerId={id} />;
    }

    if (customerParams === 'responsible-gambling') {
        return (
            <ResponsibleGamblingTab
                id={id}
                permissionGrants={permissionGrants}
            />
        );
    }

    if (customerParams === 'transaction-history') {
        return <TransactionHistoryTab id={id} />;
    }

    return <CustomerSummaryTab customerId={id} />;
});
